module.exports = __webpack_public_path__ + "img/Menu_unidad.3214b623.svg";